export const userRoles = {
    ADMIN: 'Administrator',
    PRO: 'Pro',
    BASIC: 'Basic'
}